import Vue from "vue";
import * as types from "./mutation-types";

const mutations = {
  [types.SET_PAGE_LOADED](state, data) {
    Vue.set(state, `${data.key}-loaded`, data.value);
  },

  [types.SET_PAGE_LOADING](state, data) {
    Vue.set(state, `${data.key}-loading`, data.value);
  }
};

export default mutations;
